module.exports = __webpack_public_path__ + "static/img/修改备份8.0c024b40.png";